// Extracted from `src/features/patientContext/const.ts`, which keeps its other
// three exports. On the INERT door because its app readers are constants
// modules, which the UI door would cost the whole patients barrel.

/**
 * The stored gender values, in the order every gender picker renders them.
 *
 * `label` is the untranslated fallback, for the surfaces with no `intl`.
 */
export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
  { value: 'unknown', label: 'Unknown' },
];
